export enum EquipmentRef {
  AIR_CONDITIONING = 'airConditioning',
  AIR_SAMPLE = 'airSample',
  AUTO_FLUSH = 'autoFlush',
  BACKFLOW_PREVENTER = 'backflowPreventer',
  BALNEO_WHIRLPOOL = 'balneoWhirlpool',
  BIBRONNERIE_MILK_SAMPLE = 'bibronnerieMilkSample',
  BIBRONNERIE_SURFACE_SAMPLE = 'bibronnerieSurfaceSample',
  BYPASS = 'bypass',
  CHLORINATION_STATION = 'chlorinationStation',
  CIRCULATION_PUMP = 'circulationPump',
  COLD_GENERAL_FLOW = 'coldGeneralFlow',
  COLD_INCOMING = 'coldIncoming',
  COLD_TANK = 'coldTank',
  CURVE_TEMPERATURE = 'curveTemperature',
  DEAERATOR = 'deaerator',
  DIALYSIS_WATER = 'dialysisWater',
  DISH_WATER = 'dishWater',
  ENDOSCOPE = 'endoscope',
  ENDOSCOPE_WASHER_WATER_INCOME = 'endoscopeWasherWaterIncome',
  ENDOSCOPE_WASHER_WATER_RINSE = 'endoscopeWasherWaterRinse',
  FILM_FORMING = 'filmForming',
  FITTING = 'fitting',
  FOOD_SAMPLE = 'foodSample',
  FOOD_SURFACE = 'foodSurface',
  HEAT_EXCHANGER = 'heatExchanger',
  HEATING_CORD = 'heatingCord',
  HOT_COLLECTIVE_TANK = 'hotCollectiveTank',
  HOT_COLUMN_NON_LOOPED = 'hotColumnNonLooped',
  HOT_GENERAL_FLOW = 'hotGeneralFlow',
  HOT_GENERAL_RETURN = 'hotGeneralReturn',
  HOT_INDIVIDUAL_TANK = 'hotIndividualTank',
  HOT_LOOP_RETURN = 'hotLoopReturn',
  HOT_LOOP_START = 'hotLoopStart',
  INSULATION = 'insulation',
  LEGIONELLA_FILTER = 'legionellaFilter',
  LINEN_SAMPLE = 'linenSample',
  LOW_POINT_NETWORK = 'lowPointNetwork',
  NON_RETURN_PROTECTION = 'nonReturnProtection',
  POOL_BALNEO = 'poolBalneo',
  PROBE = 'probe',
  PUMP = 'pump',
  PURIFIED_WATER = 'purifiedWater',
  SLEEVES_TEST = 'sleevesTest',
  SOFTENER = 'softener',
  SURFACE_SAMPLE = 'surfaceSample',
  THERMOSTAT = 'thermostat',
  USE_BACT_CONTROLLED_WATER = 'useBactControlledWater',
  USE_INDIVIDUAL_BALNEO = 'useIndividualBalneo',
  USE_LEGIONELLA = 'useLegionella',
  USE_LEGIONELLA_VULNERABLE = 'useLegionellaVulnerable',
  USE_POTABILITY = 'usePotability',
  USE_PURGED = 'usePurged',
  USE_STD_CARE_WATER = 'useStdCareWater',
  VALVE = 'valve',
  WATER_FILTER = 'waterFilter',
  WATER_FOUNTAIN = 'waterFountain',
  WATER_FOUNTAIN_GROUP = 'waterFountainGroup',
  WATER_METER = 'waterMeter',
  COLD_ROOM_NEGATIVE = 'coldRoomNegative',
  COLD_ROOM_POSITIVE = 'coldRoomPositive',
  AMBIENT = 'ambient',
  WATER_METER_MAIN = 'waterMeterMain',
  WATER_METER_SUB = 'waterMeterSub',
  GAS_METER_MAIN = 'gasMeterMain',
  GAS_METER_SUB = 'gasMeterSub',
  ELECTRICITY_METER_MAIN = 'electricityMeterMain',
  ELECTRICITY_METER_SUB = 'electricityMeterSub',
  PHOTOVOLTAIC_METER_MAIN = 'photovoltaicMeterMain',
  THERMAL_METER_MAIN = 'thermalMeterMain',
  THERMAL_METER_SUB = 'thermalMeterSub',
  FUEL_METER_MAIN = 'fuelMeterMain',
  FUEL_METER_SUB = 'fuelMeterSub',
  TEMPERATURE_ROOM = 'temperatureRoom',
  SET_POINT_ROOM = 'setPointRoom',
  TEMPERATURE_HEATING_CIRCUIT_SET_POINT = 'tempHeatingCircuitSetPoint',
  OUISENSE_TEMPERATURE_HEATING_CIRCUIT_SET_POINT = 'ouisenseTemperatureHeatingCircuitSetPoint',
  TEMPERATURE_HEATING_CIRCUIT_DEPARTURE = 'tempHeatingCircuitDeparture',
  TEMPERATURE_OUTSIDE = 'temperatureOutside',
  HYGRO_OUTSIDE = 'hygroOutside',
  TEMPERATURE_HEATING_CIRCUIT_DELTA = 'temperatureHeatingCircuitDelta',
  TEMPERATURE_HEATING_PRODUCTION_DEPARTURE = 'temperatureHeatingProductionDeparture',
  TEMPERATURE_HEATING_PRODUCTION_SET_POINT = 'temperatureHeatingProductionSetPoint',
  TEMPERATURE_HEATING_PRODUCTION_RETURN = 'temperatureHeatingProductionReturn',
  DEFAULT_BATTERY = 'defaultBattery',
  DEFAULT_PUMP = 'defaultPump',
  CONNECTIVITY_LORA = 'connectivityLora',
  DEFAULT_COM = 'defaultCom',
  DEFAULT_MANUAL = 'defaultManual',
  DEFAULT_CRITICAL = 'defaultCritical',
  OTHER_DEFAULT = 'otherDefault',
  DISTRIBUTION_HEATING = 'distributionHeating',
  ZONE_TEMPERATURE = 'zoneTemperature',
  MACRO_ZONE_TEMPERATURE = 'macroZoneTemperature',
  PRODUCTION_HEATING = 'productionHeating',
  HOT_WATER = 'hotWater',
  ZONE_CTA = 'zoneCta',
  ZONE_VMC = 'zoneVmc',
  ZONE_LIGHT = 'zoneLight',
  TEMPERATURE_CTA_SET_POINT = 'temperatureCtaSetPoint',
  TEMPERATURE_CTA_SET_POINT_WRITE = 'temperatureCtaSetPointWrite',
  TEMPERATURE_CTA_SET_POINT_WRITE_BLOWING = 'temperatureCtaSetPointWriteBlowing',
  AIR_FLOW_DETECTION_CTA = 'airFlowDetectionCta',
  TEMPERATURE_CTA_BLOWING = 'temperatureCtaBlowing',
  TEMPERATURE_CTA_AMBIENT = 'temperatureCtaAmbient',
  TEMPERATURE_CTA_RECOVERY = 'temperatureCtaRecovery',
  SURPRESSURE_CTA_AMBIENT = 'surpressureCtaAmbient',
  SURPRESSURE_CTA_SET_POINT = 'surpressureCtaSetPoint',
  CO2 = 'co2',
  CO2_SET_POINT = 'co2SetPoint',
  HUMIDITY = 'humidity',
  MODE_BLOWING_CTA = 'modeBlowingCta',
  ELECTRICITY_POWER_AVG = 'electricityPowerAvg',
  ELECTRICITY_POWER_MAX = 'electricityPowerMax',
  ELECTRICITY_POWER_SUBSCRIPTION = 'electricityPowerSubscription',
  ELECTRICITY_MACRO_METER = 'electricityMacroMeter',
  MODE_BLOWING = 'modeBlowing',
  MODE_RECOVERY = 'modeRecovery',
  MODE_BLOWING_CTA_SET_POINT = 'modeBlowingCtaSetPoint',
  SPEED_CTA_SET_POINT = 'speedCtaSetPoint',
  MIXING_AIR_OUTPUT = 'mixingAirOutput',
  MIXING_AIR_MANUAL_AUTO = 'mixingAirManualAuto',
  MIXING_AIR_MANUAL_OUTPUT = 'mixingAirManualOutput',
  MODE_BLOWING_SET_POINT = 'modeBlowingSetPoint',
  MODE_RECOVERY_SET_POINT = 'modeRecoverySetPoint',
  DEFAULT_CTA = 'defaultCta',
  DEFAULT_ELEC = 'defaultElec',
  DEFAULT_REVERSE_CTA = 'defaultReverseCta',
  REVERSE_DEFAULT_ELEC = 'reverseDefaultElec',
  DISTRIBUTION_CONSTANT = 'distributionConstant',
  LIGHT_DAY = 'lightDay',
  LIGHT_NIGHT = 'lightNight',
  TEMPERATURE_HEATING_CIRCUIT_RETURN = 'tempHeatingCircuitReturn',
  // Tag_Hypervision (7), onglet « Circuit régulé » — points d'un compteur de chaleur posé sur un circuit
  // (RIMSEC lu en Modbus par un UC100 Milesight, ou Exigo). Tous en lecture seule, un device par point.
  // Température du départ primaire (avant V3V) : série temperature, comme les autres sondes du circuit.
  TEMP_PRIMARY = 'tempPrimary',
  // Débit instantané en L/h : série flowRate (PAS waterFlow, qui est la vitesse d'eau DT en m/s).
  FLOW = 'flow',
  // Puissance thermique instantanée en W : série power.
  POWER = 'power',
  // Volume cumulé en L (index du compteur, pas une consommation d'eau) : série volume.
  VOLUME = 'volume',
  // Énergie cumulée en kWh lue sur le compteur (point Exigo « Energie ») : série energy, un index brut, sans
  // les consommations calculées du pipeline compteur (un compteur de chaleur à facturer se tague thermalMeterSub).
  ENERGY = 'energy',
  TEMPERATURE_CIRCUIT_DEPARTURE = 'tempCircuitDeparture',
  TEMPERATURE_CIRCUIT_RETURN = 'tempCircuitReturn',
  TEMPERATURE_CIRCUIT_SET_POINT = 'tempCircuitSetPoint',
  ONLINE_COUNTER = 'onlineCounter',
  PROBE_PRODUCTION = 'probeProduction',
  DEAERATOR_PRODUCTION = 'deaeratorProduction',
  NON_RETURN_PROTECTION_PRODUCTION = 'nonReturnProtectionProduction',
  BACKFLOW_PREVENTER_GROUP = 'backflowPreventerGroup',
  NON_RETURN_PROTECTION_DISTRIBUTION = 'nonReturnProtectionDistribution',
  PROBE_DISTRIBUTION = 'probeDistribution',
  DEAERATOR_DISTRIBUTION = 'deaeratorDistribution',
  VALVE_DISTRIBUTION = 'valveDistribution',
  VALVE_USAGE = 'valveUsage',
  CLOUD_CONNECTOR = 'cloudConnector',
  ZONE_BALNEO = 'zoneBalneo',
  TEMPERATURE_BALNEO = 'temperatureBalneo',
  FREE_CHLORINE_BALNEO = 'freeChlorineBalneo',
  ACTIVE_CHLORINE_BALNEO = 'activeChlorineBalneo',
  PH_BALNEO = 'phBalneo',
  FAN_RECOVERY = 'fanRecovery',
  FAN_RECOVERY_MANUAL_AUTO = 'fanRecoveryManualAuto',
  FAN_RECOVERY_MANUAL_OUTPUT = 'fanRecoveryManualOutput',
  FAN_BLOWING = 'fanBlowing',
  FAN_BLOWING_MANUAL_AUTO = 'fanBlowingManualAuto',
  FAN_BLOWING_MANUAL_OUTPUT = 'fanBlowingManualOutput',
  BATTERY_HOT_MANUAL_AUTO = 'batteryHotManualAuto',
  BATTERY_HOT_MANUAL_OUTPUT = 'batteryHotManualOutput',
  BATTERY_COLD_MANUAL_AUTO = 'batteryColdManualAuto',
  BATTERY_COLD_MANUAL_OUTPUT = 'batteryColdManualOutput',
  CHANGEOVER_MANUAL_AUTO = 'changeoverManualAuto',
  CHANGEOVER_OUTPUT = 'changeoverOutput',
  BATTERY_CHANGEOVER_MANUAL_AUTO = 'batteryChangeoverManualAuto',
  BATTERY_CHANGEOVER_MANUAL_OUTPUT = 'batteryChangeoverManualOutput',
  DAMPER = 'damper',
  DAMPER_MANUAL_AUTO = 'damperManualAuto',
  MODE = 'mode',
  AUTHORIZED_OFF = 'authorizedOff',
  ON_OFF_READ = 'onOffRead',
  CHILLER_UNIT = 'chillerUnit',
  PRODUCTION_COOLING = 'productionCooling',
  TEMPERATURE_COOLING_DEPARTURE = 'temperatureCoolingDeparture',
  TEMPERATURE_COOLING_RETURN = 'temperatureCoolingReturn',
  DEFAULT_CHILLER = 'defaultChiller',
  DEFAULT_FLOW = 'defaultFlow',
  TEMPERATURE_COOLING_PRODUCTION_DEPARTURE = 'temperatureCoolingProductionDeparture',
  TEMPERATURE_COOLING_PRODUCTION_RETURN = 'temperatureCoolingProductionReturn',
  HEATING_BOILER = 'heatingBoiler',
  HEAT_PUMP = 'heatPump',
  // Production PAC / groupe froid (synoptique heatPumpChiller) : macro-équipement du départ / retour
  // de production, parent des deux sondes ci-dessous (`productionHeatPumpChiller_tempProduction*`).
  PRODUCTION_HEAT_PUMP_CHILLER = 'productionHeatPumpChiller',
  TEMP_PRODUCTION_DEPARTURE = 'tempProductionDeparture',
  TEMP_PRODUCTION_RETURN = 'tempProductionReturn',
  DISTRIBUTION_CHANGEOVER = 'distributionChangeover',
  DISTRIBUTION_COLD = 'distributionCold',
  DISTRIBUTION_CONSTANT_HEATING = 'distributionCstHeating',
  DISTRIBUTION_CONSTANT_CHANGEOVER = 'distributionCstChangeover',
  DISTRIBUTION_CONSTANT_COLD = 'distributionCstCold',
  CONSTANT_SET_POINT_WRITE = 'constantSetPointWrite',
  SHIFT_SET_POINT = 'shiftSetPoint',
  TEMP_BOTTLE_SECONDARY_DEPARTURE = 'tempBottleSecondaryDeparture',
  TEMP_BOTTLE_SECONDARY_RETURN = 'tempBottleSecondaryReturn',
  TEMP_BOTTLE_PRIMARY_DEPARTURE = 'tempBottlePrimaryDeparture',
  TEMP_BOTTLE_PRIMARY_RETURN = 'tempBottlePrimaryReturn',
  STATE_PUMP = 'statePump',
  MANUAL_AUTO_PUMP = 'manualAutoPump',
  FLOW_SWITCH = 'flowSwitch',
  MANUAL_AUTO = 'manualAuto',
  STATUS = 'status',
  DELTA_SET_POINT_START = 'deltaSetPointStart',
  MIN_STOP_TIME = 'minStopTime',
  MIN_WORK_TIME = 'minWorkTime',
  AQUASTAT_WRITE = 'aquastatWrite',
  TEMPERATURE_DEPARTURE = 'temperatureDeparture',
  TEMPERATURE_RETURN = 'temperatureReturn',
  SET_POINT_MANUAL_OUTPUT = 'setPointManualOutput',
  SET_POINT_MANUAL_AUTO = 'setPointManualAuto',
  TEMPERATURE_CIRCUIT_SET_POINT_WRITE = 'tempCircuitSetPointWrite',
  TEMPERATURE_CIRCUIT_SET_POINT_WRITE_COLD = 'tempCircuitSetPointWriteCold',
  TEMPERATURE_CIRCUIT_SET_POINT_WRITE_HOT = 'tempCircuitSetPointWriteHot',
  T_EXT_STOP_PUMP = 'tExtStopPump',
  T_EXT_STOP_PUMP_COLD = 'tExtStopPumpCold',
  T_EXT_STOP_PUMP_HOT = 'tExtStopPumpHot',
  MODE_HOT_COLD = 'modeHotCold',
  PUMP_MANUAL_AUTO = 'pumpManualAuto',
  V3V_OUTPUT = 'v3vOutput',
  V3V_MANUAL_OUTPUT = 'v3vManualOutput',
  V3V_MANUAL_AUTO = 'v3vManualAuto',
  TEMPERATURE_CHANGEOVER_CIRCUIT_SET_POINT = 'tempChangeoverCircuitSetPoint',
  TEMPERATURE_CHANGEOVER_CIRCUIT_DEPARTURE = 'tempChangeoverCircuitDeparture',
  TEMPERATURE_CHANGEOVER_CIRCUIT_RETURN = 'tempChangeoverCircuitReturn',
  TEMPERATURE_COLD_CIRCUIT_SET_POINT = 'tempColdCircuitSetPoint',
  TEMPERATURE_COLD_CIRCUIT_DEPARTURE = 'tempColdCircuitDeparture',
  TEMPERATURE_COLD_CIRCUIT_RETURN = 'tempColdCircuitReturn',
  Y1_WATER_LAW = 'y1waterLaw',
  Y2_WATER_LAW = 'y2waterLaw',
  Y3_WATER_LAW = 'y3waterLaw',
  Y4_WATER_LAW = 'y4waterLaw',
  Y5_WATER_LAW = 'y5waterLaw',
  Y6_WATER_LAW = 'y6waterLaw',
  Y7_WATER_LAW = 'y7waterLaw',
  Y8_WATER_LAW = 'y8waterLaw',
  Y1_WATER_LAW_HOT = 'y1waterLawHot',
  Y2_WATER_LAW_HOT = 'y2waterLawHot',
  Y3_WATER_LAW_HOT = 'y3waterLawHot',
  Y4_WATER_LAW_HOT = 'y4waterLawHot',
  Y5_WATER_LAW_HOT = 'y5waterLawHot',
  Y6_WATER_LAW_HOT = 'y6waterLawHot',
  Y7_WATER_LAW_HOT = 'y7waterLawHot',
  Y8_WATER_LAW_HOT = 'y8waterLawHot',
  Y1_WATER_LAW_COLD = 'y1waterLawCold',
  Y2_WATER_LAW_COLD = 'y2waterLawCold',
  Y3_WATER_LAW_COLD = 'y3waterLawCold',
  Y4_WATER_LAW_COLD = 'y4waterLawCold',
  Y5_WATER_LAW_COLD = 'y5waterLawCold',
  Y6_WATER_LAW_COLD = 'y6waterLawCold',
  Y7_WATER_LAW_COLD = 'y7waterLawCold',
  Y8_WATER_LAW_COLD = 'y8waterLawCold',
  HOT_DEPARTURE_SECONDARY = 'hotDepartureSecondary',
  TEMPERATURE_SET_POINT_DEPARTURE_WRITE = 'temperatureSetPointDepartureWrite',
  TEMPERATURE_SET_POINT_DEPARTURE_READ = 'temperatureSetPointDepartureRead',
  TEMPERATURE_SET_POINT_TANK_WRITE = 'temperatureSetPointTankWrite',
  TEMPERATURE_SET_POINT_TANK_READ = 'temperatureSetPointTankRead',
  DEFAULT_PUMP_LOOP = 'defaultPumpLoop',
  STATE_PUMP_LOOP = 'statePumpLoop',
  MANUAL_AUTO_PUMP_LOOP = 'manualAutoPumpLoop',
  DEFAULT_PUMP_PRIMARY = 'defaultPumpPrimary',
  STATE_PUMP_PRIMARY = 'statePumpPrimary',
  MANUAL_AUTO_PUMP_PRIMARY = 'manualAutoPumpPrimary',
  DEFAULT_PUMP_SECONDARY_EXCH = 'defaultPumpSecondaryExch',
  STATE_PUMP_SECONDARY_EXCH = 'statePumpSecondaryExch',
  MANUAL_AUTO_PUMP_SECONDARY_EXCH = 'manualAutoPumpSecondaryExch',
  DEFAULT_PUMP_PRIMARY_EXCH = 'defaultPumpPrimaryExch',
  STATE_PUMP_PRIMARY_EXCH = 'statePumpPrimaryExch',
  MANUAL_AUTO_PUMP_PRIMARY_EXCH = 'manualAutoPumpPrimaryExch',
  HOT_DEPARTURE_PRIMARY_EXCH = 'hotDeparturePrimaryExch',
  HOT_DEPARTURE_SECONDARY_EXCH = 'hotDepartureSecondaryExch',
  V3V_OUTPUT_EXCH = 'v3vOutputExch',
  V3V_MANUAL_AUTO_EXCH = 'v3vManualAutoExch',
  V3V_MANUAL_OUTPUT_EXCH = 'v3vManualOutputExch',
  TEMPERATURE_SET_POINT_EXCH_READ = 'temperatureSetPointExchRead',
  TEMPERATURE_SET_POINT_EXCH_WRITE = 'temperatureSetPointExchWrite',
  TEMPERATURE_SECONDARY_DEPARTURE_EXCH = 'temperatureSecondaryDepartureExch',
  ON_OFF = 'onOff',
  MODE_HEAT_COLD_WRITE = 'modeHeatColdWrite',
  MODE_HEAT_COLD_READ = 'modeHeatColdRead',
  SET_POINT_READ_ONLY = 'setPointReadOnly',
  SET_POINT_WRITE = 'setPointWrite',
  TEMP_EVAP_IN = 'tempEvapIn',
  TEMP_EVAP_OUT = 'tempEvapOut',
  TEMP_COND_IN = 'tempCondIn',
  TEMP_COND_OUT = 'tempCondOut',
  TEMP_WATER_IN = 'tempWaterIn',
  TEMP_WATER_OUT = 'tempWaterOut',
  PRESSURE_WATER_IN = 'pressureWaterIn',
  PRESSURE_WATER_OUT = 'pressureWaterOut',
  HIGH_PRESSURE = 'highPressure',
  LOW_PRESSURE = 'lowPressure',
  DEFAULT_GENERAL = 'defaultGeneral',
  DEFAULT_CODE_LAST = 'defaultCodeLast',
  DEFAULT_GROUP = 'defaultGroup',
  ENERGY_METER = 'energyMeter',
  DEFROST_STATUS = 'defrostStatus',
  COMPRESSOR_STATUS = 'compressorStatus',
  DEFAULT_FLOW_SWITCH = 'defaultFlowSwitch',
  TVOC = 'tvoc',
  TEMPERATURE_ANTI_FROST = 'temperatureAntiFrost',
  TEMPERATURE_CTA_AIR_OUT = 'temperatureCtaAirOut',
  TEMPERATURE_CTA_AIR_IN = 'temperatureCtaAirIn',
  TEMPERATURE_CTA_AIR_AMBIENT = 'temperatureCtaAirAmbient',
  PRESSURE_CTA_BLOWING = 'pressureCtaBlowing',
  PRESSURE_CTA_RECOVERY = 'pressureCtaRecovery',
  FLOW_CTA_BLOWING = 'flowCtaBlowing',
  FLOW_CTA_RECOVERY = 'flowCtaRecovery',
  HUMIDITY_BLOWING = 'humidityBlowing',
  HUMIDITY_RECOVERY = 'humidityRecovery',
  HUMIDITY_AMBIENT = 'humidityAmbient',
  HUMIDITY_SET_POINT = 'humiditySetPoint',
  HUMIDIFICATION_ANALOG_OUTPUT = 'humidificationAnalogOutput',
  HUMIDIFICATION_ANALOG_MANUAL_AUTO = 'humidificationAnalogManualAuto',
  HUMIDIFICATION_ANALOG_MANUAL_OUTPUT = 'humidificationAnalogManualOutput',
  HUMIDIFICATION_DIGITAL_OUTPUT = 'humidificationDigitalOutput',
  HUMIDIFICATION_DIGITAL_MANUAL_AUTO = 'humidificationDigitalManualAuto',
  MODE_BLOWING_MANUAL_SET_POINT = 'modeBlowingManualSetPoint',
  MODE_RECOVERY_MANUAL_SET_POINT = 'modeRecoveryManualSetPoint',
  CO2_OUTPUT = 'co2Output',
  BATTERY_HOT_OUTPUT = 'batteryHotOutput',
  BATTERY_COLD_OUTPUT = 'batteryColdOutput',
  EXCHANGER_OUTPUT = 'exchangerOutput',
  EXCHANGER_MANUAL_AUTO = 'exchangerManualAuto',
  EXCHANGER_MANUAL_OUTPUT = 'exchangerManualOutput',
  ELECTRIC_BATTERY_OUTPUT = 'electricBatteryOutput',
  ELECTRIC_BATTERY_MANUAL_AUTO = 'electricBatteryManualAuto',
  ELECTRIC_BATTERY_MANUAL_OUTPUT = 'electricBatteryManualOutput',
  ELECTRIC_BATTERY_OUTPUT_STAGE_CONTROLLER = 'electricBatteryOutputStageController',
  ELECTRIC_BATTERY_STATUS_STAGE_1 = 'electricBatteryStatusStage1',
  ELECTRIC_BATTERY_STATUS_STAGE_2 = 'electricBatteryStatusStage2',
  ELECTRIC_BATTERY_STATUS_STAGE_3 = 'electricBatteryStatusStage3',
  ELECTRIC_BATTERY_STATUS_STAGE_4 = 'electricBatteryStatusStage4',
  DAMPER_RECOVERY = 'damperRecovery',
  DAMPER_RECOVERY_MANUAL_AUTO = 'damperRecoveryManualAuto',
  DAMPER_AIR_OUT = 'damperAirOut',
  DAMPER_AIR_OUT_MANUAL_AUTO = 'damperAirOutManualAuto',
  DEFAULT_VMC = 'defaultVMC',
  FORCED_RUNNING_GV = 'forcedRunningGv',
  FORCED_RUNNING_PV = 'forcedRunningPv',
  FORCED_BUTTON_SPEED_1 = 'forcedButtonSpeed1',
  FORCED_BUTTON_SPEED_2 = 'forcedButtonSpeed2',
  FORCED_BUTTON_SPEED_3 = 'forcedButtonSpeed3',
  MEDICAL_FLUID_DEFAULT = 'medicalFluidDefault',
  REVERSE_MEDICAL_FLUID_DEFAULT = 'reverseMedicalFluidDefault',
  // Point CTA en écriture qui acquitte toutes les alarmes du régulateur. Impulsion :
  // écrire ON, puis repasser la valeur à NULL ~30 s après (cf. Tag_Hypervision, onglet CTA).
  ACK_GROUND_ALARM = 'ackGroundAlarm',
  // Tag_Hypervision (6), onglet « Regul terminale » — points en lecture seule.
  // État de la vanne du thermostat de zone (THZ) : ouverture en %.
  POSITION_VALVE = 'positionValve',
  // Luminosité extérieure du capteur LoRa de la zone d'éclairage : Numeric en lux.
  OUTDOOR_ILLUMINANCE = 'outdoorIlluminance',
  // Extracteur additionnel d'une CTA (onglet CTA) : état de marche, Bool en lecture seule, série DEFAULT.
  // Son défaut ne crée pas de ref : ref partagé DEFAULT_CTA + ctaType `defaultAdditionalExtractor`.
  STATE_ADDITIONAL_EXTRACTOR = 'stateAdditionalExtractor',
  // État électrique d'une zone d'éclairage (`zoneLight_stateElec`) : Bool On/Off remonté par le TGBT,
  // lecture seule, série DEFAULT.
  STATE_ELEC = 'stateElec',
}
